<form *ngIf="user" #userForm="ngForm" (ngSubmit)="onSubmit()" class="content-card" novalidate>
  <mat-card class="form-card">
    <mat-card-content>
      <mat-form-field>
        <input matInput type="email" placeholder="Email" name="email" maxlength="160" [(ngModel)]="user.email" email required>
      </mat-form-field>
      <div class="checkbox-form-field">
          <mat-checkbox name="emailConfirmed" disabled="disabled" [(ngModel)]="user.emailConfirmed" >Email confirmed</mat-checkbox>
      </div>
      <mat-form-field>
        <input matInput placeholder="First name" name="firstName" maxlength="50" [(ngModel)]="user.firstName">
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="Last name" name="lastName" maxlength="50" [(ngModel)]="user.lastName">
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="Phone number" name="phoneNumber"
        [(ngModel)]="user.phoneNumber" [imask]="phoneMask" [unmask]="true" minlength="10" maxlength="15" require>
      </mat-form-field>
      <div class="checkbox-form-field">
          <mat-checkbox name="active" [(ngModel)]="user.active">Active</mat-checkbox>
      </div>
      <mat-form-field>
        <mat-select placeholder="Role group" [(ngModel)]="user.roleGroup" (ngModelChange)="onRoleGroupChange($event)" name="roleGroup" required>
          <mat-option *ngFor="let role of roles" [value]="role">{{role}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-select placeholder="Company" [(ngModel)]="user.companyId" name="companyId">
          <mat-option [value]="0">None</mat-option>
          <mat-option *ngFor="let company of companies" [value]="company.id">{{company.name}}</mat-option>
        </mat-select>
      </mat-form-field>
    </mat-card-content>
    <mat-card-actions align="end">
      <button mat-raised-button color="accent" type="button" (click)="returnBack()">Cancel</button>
      <button mat-raised-button color="primary" [disabled]="!userForm.valid" type="submit">Save</button>
    </mat-card-actions>
  </mat-card>
</form>
